import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=97e9c1ea&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=97e9c1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e9c1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e9c1ea')) {
      api.createRecord('97e9c1ea', component.options)
    } else {
      api.reload('97e9c1ea', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=97e9c1ea&scoped=true&", function () {
      api.rerender('97e9c1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2p9iagVLaCu/JS/comp/DateRange.vue"
export default component.exports